namespace RioERP.Web.Enums {
    export enum ProductType {
        PenDrive = 1,
        GoogleDrive = 2,
        Book = 3,
        EBook = 4,
        TestSeries = 5,
        Others = 6
    }
    Serenity.Decorators.registerEnumType(ProductType, 'RioERP.Web.Enums.ProductType');
}
